/* hs-eslint ignored failing-rules */
/* eslint-disable conversations/no-dynamic-i18n */

'use es6';

import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import PropTypes from 'prop-types';
import { getVerboseDateText } from 'conversations-message-history/util/getVerboseDateText';
import { getTimestamp, getAudit } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import DashedLabel from '../atoms/DashedLabel';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import FullSenderName from '../senders/components/FullSenderName';
import { getData } from 'conversations-message-history/senders/operators/getters';
import { generateSenderKeyFromMessageAudit } from 'conversations-message-history/senders/operators/generateSenderKeyFromMessageAudit';
import { hasThreadBeenClosed } from 'conversations-message-history/thread-status-update/operators/hasThreadBeenClosed';
import { hasThreadBeenOpened } from 'conversations-message-history/thread-status-update/operators/hasThreadBeenOpened';
import { getType } from 'conversations-message-history/audit/operators/auditGetters';
import { getAgentIdFromAudit } from 'conversations-message-history/audit/operators/getAgentIdFromAudit';
import { MANUAL, VISITOR } from 'conversations-message-history/audit/constants/auditTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadStatusUpdateMessage = ({
  message,
  senders,
  userId
}) => {
  // only render on re-open event

  const audit = getAudit(message);
  const agentId = getAgentIdFromAudit(audit);
  const isCurrentAgent = agentId === userId;
  let messageText;
  if (hasThreadBeenClosed(message)) {
    messageText = isCurrentAgent ? 'conversations-inbox-message-history.status.closedByCurrentAgent' : 'conversations-inbox-message-history.status.closedBy';
  } else if (hasThreadBeenOpened(message)) {
    const auditType = getType(audit);
    const showMessage = auditType && (auditType === MANUAL || auditType === VISITOR);
    if (showMessage) {
      messageText = isCurrentAgent ? 'conversations-inbox-message-history.status.reopenedByCurrentAgent' : 'conversations-inbox-message-history.status.reopenedBy';
    } else {
      messageText = null;
    }
  }
  if (!messageText) {
    return null;
  }
  const timestamp = I18n.moment(getTimestamp(message));
  const updaterKey = generateSenderKeyFromMessageAudit(message);
  const updatedSender = senders.get(updaterKey);
  const agentName = isCurrentAgent ? undefined : /*#__PURE__*/_jsx(FullSenderName, {
    sender: getData(updatedSender)
  });
  return /*#__PURE__*/_jsx(DashedLabel, {
    transparent: true,
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: messageText,
      options: {
        agentName,
        dateString: getVerboseDateText(timestamp)
      }
    })
  });
};
ThreadStatusUpdateMessage.displayName = 'ThreadStatusUpdateMessage';
ThreadStatusUpdateMessage.propTypes = {
  message: RecordPropType('ThreadStatusUpdateMessage').isRequired,
  senders: SenderMap,
  userId: PropTypes.number.isRequired
};
export default ThreadStatusUpdateMessage;